import Vue from 'vue'
import Vuex from 'vuex'
const fb = require('./firebaseConfig.js')

import { firestorePlugin } from "vuefire";
import { vuexfireMutations, firestoreAction } from "vuexfire";

Vue.use(Vuex)

// handle page reload
fb.auth.onAuthStateChanged(user => {
    if (user) {
        store.commit('setCurrentUser', user)
        store.dispatch('bindBooksRef')
        store.dispatch('fetchUserProfile')
        fb.currentUser = user
        fb.usersCollection.doc(user.uid).onSnapshot(doc => {
            store.commit('setUserProfile', doc.data())
        });
    }
})

export const store = new Vuex.Store({
    state: {
        currentUser: null,
        userProfile: {},
        enabled: null,
        school: null,
        books: []

    },
    actions: {
        bindBooksRef: firestoreAction((context) => {
            console.log('dflsdlf')
            return context.bindFirestoreRef("books", fb.db.collection("books"));
        }),
        clearData({ commit }) {
            commit('setCurrentUser', null)
            commit('setUserProfile', {})
        },
        hideAppbar({ commit }) {
            commit('setAppbar', true)
        },
        showAppbar({ commit }) {
            commit('setAppbar', false)
        },
        fetchUserProfile({ commit, state }) {
            fb.usersCollection.doc(state.currentUser.uid).get().then(res => {
                if (res.exists)
                    commit('setUserProfile', res.data())
                else {
                }
            }).catch(err => {
                console.log(err)
            })
        },
        setEnabledTrue({ commit, state }) {
            commit('setEnabled', true)
        },
        setEnabledFalse({ commit, state }) {
            commit('setEnabled', false)
        },
        updateProfile({ commit, state }, data) {
            // let name = data.name
            // let title = data.title

            fb.usersCollection.doc(state.currentUser.uid).update({ name, title }).then(user => {
                // update all posts by user to reflect new name
                fb.postsCollection.where('userId', '==', state.currentUser.uid).get().then(docs => {
                    docs.forEach(doc => {
                        fb.postsCollection.doc(doc.id).update({
                            userName: name
                        })
                    })
                })
                // update all comments by user to reflect new name
                fb.commentsCollection.where('userId', '==', state.currentUser.uid).get().then(docs => {
                    docs.forEach(doc => {
                        fb.commentsCollection.doc(doc.id).update({
                            userName: name
                        })
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    },
    mutations: {
        setCurrentUser(state, val) {
            state.currentUser = val
        },
        setUserProfile(state, val) {
            state.userProfile = val
        },
        setEnabled(state, val) {
            state.enabled = val
        },
        SET_SHARE_ITEM(state, item) {
            state.shareItem = item
        },
        setSchool(state, val) {
            state.school = val
        },
        ...vuexfireMutations


    },
    getters: {
        currentUser: state => {
            return state.currentUser
        },
        enabled: state => {
            return state.enabled
        },

        userProfile: state => {
            return state.userProfile
        },
        currentSchool: state => {
            return state.school
        },
        books: (state) => {
            return state.books;
        }
    }
})
